import React from 'react';

interface IProps {
  isChecked: boolean;
  setIsChecked?: (isChecked: boolean) => void;
  disabled?: boolean;
  id: string;
}

const Checkbox: React.FC<IProps> = ({ isChecked, setIsChecked = () => null, disabled, id }) => {
  return (
    <input
      id={id}
      className="k-checkbox k-checkbox-md k-rounded-md hoverable--darker"
      type="checkbox"
      checked={isChecked}
      disabled={disabled}
      onClick={() => setIsChecked(!isChecked)}
      readOnly
    />
  );
};

export default Checkbox;
